import Game from '@/components/views/Game';
import chapters from "@/router/chapters.routes";
import curveballs from "@/router/curveballs.routes";
import budgets from "@/router/budgets.routes";
import shop from "@/router/shop.routes";
import travel from "@/router/travel.routes";
import performance from "@/router/performance.routes";
import trickSelector from '@/router/trick-selector.routes';
import review from '@/router/review.routes';
import intros from '@/router/intros.routes';
import store from "@/store";

export default [
	{
		path: '/game',
		component: Game,
		children: [
			...chapters,
			...curveballs,
			...budgets,
			...performance,
			...trickSelector,
			...review,
			...shop,
			...travel,
			...intros,
			{
				path: '/game/start',
				beforeEnter(to, from, next) {
					store.dispatch("game/start");
					next({ path: "/game/budget" });
				},
			},
			{
				path: '/game/complete',
				beforeEnter(to, from, next) {
					store.dispatch("game/end");

					let path = "/ending/lose";
					path = store.getters["game/funds/haveWinningBalances"] ? "/ending/win" : path;
					path = store.getters["game/scores/zeroScore"] ? "/ending/fired" : path;

					store.dispatch("sound/music/fade", { volume: 0, duration: 1000 });
					store.dispatch("global/analytics/trackEndgameEvents", { state: path === "/ending/win" ? "Win" : "Lose" });

					next({ path });
				},
			},
		],
	},
];



// WEBPACK FOOTER //
// ./src/router/game.routes.js